import type { Store } from 'redux'
import configureStore from './store/configureStore'
import EventEmitter from 'eventemitter3'

class AppStore {
  static isLoaded = false
  static _store = null
  static _ee = new EventEmitter()

  static init(callback: () => void) {
    this._ee.on('load', callback)
    this._store = configureStore(() => {
      this.isLoaded = true
      this._ee.emit('load')
    })
  }

  static on(kind, callback: () => void) {
    this._ee.on(kind, callback)
  }

  static off(kind, callback: () => void) {
    this._ee.off(kind, callback)
  }

  static get store(): Store {
    return this._store
  }
}

export default AppStore



// WEBPACK FOOTER //
// ./src/AppStore.js